import { render, staticRenderFns } from "./GoodsServices.vue?vue&type=template&id=e62c4d34&scoped=true&"
import script from "./GoodsServices.vue?vue&type=script&lang=js&"
export * from "./GoodsServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e62c4d34",
  null
  
)

export default component.exports